import { render, staticRenderFns } from "./scorexmain.vue?vue&type=template&id=8d365c22&scoped=true&"
import script from "./scorexmain.vue?vue&type=script&lang=js&"
export * from "./scorexmain.vue?vue&type=script&lang=js&"
import style0 from "./scorexmain.vue?vue&type=style&index=0&id=8d365c22&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d365c22",
  null
  
)

export default component.exports